import React from 'react';

const ModeloTabelaSdaContext = React.createContext();

export default ModeloTabelaSdaContext;
